import React, { useMemo } from 'react';

import { useGetEvents } from '@vlabs/api/artemy/client';
import type { EventRecord } from '@vlabs/api/artemy/model';

import { EVENT_TARGET } from '@vlabs/monokit/entities/events/api';

import { BaseMapPoint3 } from './BaseMap.point3';
import { getMarkerPoint3 } from './getMarker.point3';

interface EventMapPoint3Props {
  event?: EventRecord;
}

export function EventMapPoint3({ event = undefined }: EventMapPoint3Props): React.JSX.Element {
  const topMatch = event?.top_match;
  const topMatchId = useMemo(() => {
    if (!topMatch) return undefined;
    const id = 'face_id' in topMatch ? topMatch.face_id : topMatch.event_id;
    return id ?? undefined;
  }, [topMatch]);

  const { data: topMatchEvents } = useGetEvents({
    top_similar_object_ids: topMatchId ? [topMatchId] : undefined,
    page_size: 100,
    target: EVENT_TARGET,
  }, {
    query: { enabled: !!topMatchId },
  });

  const markers = useMemo(() => {
    const historyMarkers = (topMatchEvents?.events ?? [])
      .filter((historyEvent) => historyEvent.event_id !== event?.event_id)
      .map(getMarkerPoint3)
      .filter((marker) => marker !== null);

    const currentMarker = getMarkerPoint3(event);

    return currentMarker
      ? [...historyMarkers, currentMarker]
      : historyMarkers;
  }, [event, topMatchEvents?.events]);

  return (
    <BaseMapPoint3
      location={event?.location}
      markers={markers}
    />
  );
}
